import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { SessionService } from 'app/components/common/session/session.service';
import { DetailsService } from 'app/components/details/details.service';
import * as uuid from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(private http: HttpClient, private translateService: TranslateService, private router: Router, private catalogueService: CatalogueService, private sessionService: SessionService,
    private detailsService: DetailsService) {
      this.sessionService.set('catalogueProperties', {
        defaultExhibitorImage: 'assets/img/no_image_available.png',
        defaultProductImage: 'assets/img/no_image_available.png'
      });
     }

  setPropertyName(type) {

    let propertyName = 'selected';

    if (type === 'master') {
      propertyName = propertyName + 'Properties';
    } else if (type === 'hierarchical') {
      propertyName = propertyName + this.capitalizeFirstLetter(type) + 'Properties';
    } else if (type === 'ods') {
      propertyName = propertyName + 'Home' + this.capitalizeFirstLetter(type);
    } else {
      propertyName = propertyName + this.capitalizeFirstLetter(type);
    }

    return propertyName;

  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  _api(translations, property) {

    translations = translations || [];

    // Fallback: idioma activo -> idioma por defecto -> primera traducción disponible
    const findByLang = (lang) => lang ? translations.find(t => t?.['language']?.includes(lang)) : undefined;
    const translation = findByLang(this.translateService.currentLang)
      || findByLang(this.translateService.defaultLang)
      || translations[0];

    return translation?.[property];

  }

  trackByItems(index: number, item: any): number {
    return item.id;
  }

  checkTab(tabToCheck, eventData) {
    if (!eventData[tabToCheck]) {
      this.goToActiveTab(eventData);
    }
  }

  goToActiveTab(eventData) {

    let url = '';

    if (eventData['filterExhibitors']) {
        url = '/exhibitors-list';
    } else if (eventData['filterProducts']) {
        url = '/products-list';
    } else if (eventData['allowNovelty']) {
        url = '/novelties-list';
    } else if (eventData['showBrandFilter']) {
        url = '/brands-list';
    } else if (eventData['mapsActive']) {
        url = '/maps-list';
    }
    
    this.router.navigate([eventData['id'] + url], {
      queryParams: {
        lang: this.mapLanguageCode(this.translateService.currentLang)
      }
    });

  }

  setCatalogueProperties(eventData) {
    const catalogueProps = { catalogueId: null };
    if((catalogueProps['catalogueId'] !== eventData['id']) && !!eventData['id']) {
      this.catalogueService.getCatalogueProperties(eventData['id']).subscribe(properties => {
        console.log('properties ok');
        console.log(properties);
        properties['catalogueId'] = eventData['id'];
        this.sessionService.set('catalogueProperties', properties);
      }, error => this.sessionService.set('catalogueProperties', {
        defaultExhibitorImage: 'assets/img/no_image_available.png',
        defaultProductImage: 'assets/img/no_image_available.png'
      }));
    }
    this.setColors(eventData);
  }


  setColors(eventData) {
    eventData['mainColor'] = this.detailsService.getPropertyByKey('colors.mainColor') || eventData['mainColor'] || "#E33737";
    eventData['color'] = this.detailsService.getPropertyByKey('colors.color') || eventData['color'] || "#E33737";
    eventData['headerColor'] = this.detailsService.getPropertyByKey('colors.headerColor') || eventData['headerColor'] || "#E0E0E0";
    eventData['languageColor'] = this.detailsService.getPropertyByKey('colors.languageColor') || eventData['languageColor'] || "#808080";
    eventData['pageColor'] = this.detailsService.getPropertyByKey('colors.pageColor') || eventData['pageColor'] || "#FBFBFB";
    eventData['featuredColor'] = this.detailsService.getPropertyByKey('colors.featuredColor') || eventData['featuredColor'] || "#3D5770";
    eventData['sponsoredColor'] = this.detailsService.getPropertyByKey('colors.sponsoredColor') || eventData['sponsoredColor'] || "#3D5770";
    
    this.sessionService.set('eventData', eventData, false);
  }

  standConvertor(standLocation:string):any {
    try {
      const valid = item => item !== undefined && item !== null && item !== '';
      const [place, pavilion, level, street, stand] = standLocation.split('/').map(segment => (segment || '').trim());
      const fairground = this.getFairground(standLocation);
      if(valid(place) && valid(pavilion) && valid(level) && valid(street) && valid(stand)) {
        return { place: fairground, pavilion, level, street, stand, successful: true };
      } else if(this.isKnownFairground(fairground)) {
        // Fairgrounds like Port Vell (PV) have no pavilion/level/street structure,
        // so the stand string arrives incomplete. Show at least the fairground name
        // followed by whatever location detail did arrive.
        const details = [pavilion, level, street, stand].filter(segment => valid(segment)).join('/');
        return { place: fairground, pavilion, level, street, stand, details, successful: false, partial: true };
      } else throw new Error("Stand data is incomplete!");
    } catch (e) {
      console.warn(uuid.v4() + "An error happened while converting the stand string!")
      return {successful: false, partial: false};
    }
  };

  getFairground(standLocation: string): string {
    return ((standLocation || '').split('/')[0] || '').trim().toUpperCase();
  }

  isKnownFairground(fairground: string): boolean {
    return !this.isEmpty(fairground) && CONSTANTS.FAIRGROUNDS.includes(fairground);
  }

  pavilionTranslationFinder(pavilionCode:string, fairground:string):string {
      let theCode = "";

      switch(`${fairground}${pavilionCode}`) {
        case "GVH4": theCode='STAND_DISPLAY.GV_H4'; break;
        case "GVZ3": theCode='STAND_DISPLAY.GV_Z3'; break;
        case "GVZ2": theCode='STAND_DISPLAY.GV_Z2'; break;
        case "GVZ1": theCode='STAND_DISPLAY.GV_Z1'; break;
        default: theCode=this.getPavilionCode(pavilionCode); break;
      }

      return theCode;
  }

  getPavilionCode(pavilionCode: string): string {
    const code = (pavilionCode || '').trim();
    if (this.isEmpty(code)) {
      return '';
    }
    switch (code.charAt(0)) {
      case 'Z':
        return code.startsWith('ZZ') ? code.slice(-2) : code;
      default:
        return code.length > 1 ? code.slice(1) : code;
    }
  }

  isEmpty(value: any): boolean {
    return value === null || value === undefined || value === '';
  }

  getLanguageShortISO(code:string): string {//FIXME Revisar si es necesario solo usar el es de es_ES
    const partes = code.split('_');
    return partes[0];
  }

  isValidLanguage(lang: string): boolean {
    const validLanguages = ['es', 'en', 'ca'];
    return validLanguages.includes(lang);
  }

  mapLanguageCode(language: string): string {
    const languageMap: { [key: string]: string } = {
      'es': 'es_ES',
      'en': 'en_GB',
      'ca': 'ca_ES'
    };
  
    return languageMap[language] || language;
  }

  isEmptyObject(obj: any): boolean {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
  }

  isEmptyOrUndefined(value: any): boolean {
    return value === undefined || value === null || value === '' || (Array.isArray(value) && value.length === 0) || (typeof value === 'object' && Object.keys(value).length === 0);
  }

  existCustomTranslate(){
    let eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    let sapCode = eventData['sapCode'];
    const customFile = this.sessionService.get('customTranslations_'+ sapCode+'_'+this.translateService.currentLang);
    if(customFile){
      return true;
    } else {
      return false;
    }
  }

  isAuth(){

    let eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    let token = this.sessionService.get('token_' + eventData['sapCode'], true);
    
    return token ? true : false;
  }

  parseBoolean(value: any): boolean {
    return !!value;
  }
  
  getFormattedDate(): string {
    const date = new Date();
  
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Los meses son de 0 a 11, por eso se suma 1
    const day = String(date.getUTCDate()).padStart(2, '0');
  
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');
    const milliseconds = String(date.getUTCMilliseconds()).padStart(3, '0');
  
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}+0000`;
  }

}
